module.exports = __webpack_public_path__ + "img/premjyotish.10027ecc.jpg";